// extracted by mini-css-extract-plugin
module.exports = {"formItem":"ReportTreatmentReminder_formItem__2Jvc5"};